module.exports = __webpack_public_path__ + "img/couponImage.c21af27e.svg";